import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Youtube, ExternalLink, Play } from 'lucide-react';

const videos = [
    {
        id: 'N1iuBcBLEGU',
        title: 'Akan Aku Maksimalkan Ramadhan Ini',
        ustadz: 'Ustadz Fatahillah Aly, S.Ag',
    },
    {
        id: 'gQb7-CXXaVo',
        title: 'Bekal Menuju Perjalanan Pulang',
        ustadz: 'Ustadz Abu Haidar As-Sundawi',
    },
    {
        id: 'rGLSOIbZPK4',
        title: 'Andaikan Ini Ramadhan Terakhirku',
        ustadz: 'Ustadz Zahir Al Minangkabawi',
    },
    {
        id: 'YydG0GKJX8U',
        title: 'Riyadush Shalihin',
        ustadz: 'Ustadz Fuad Mubarak, Lc.',
    },
    {
        id: 'DcB5Mnz_xlU',
        title: 'Saat Manusia Dihisab',
        ustadz: 'Ustadz Abu Haidar As-Sundawy',
    },
    {
        id: 'FV_NLQ9M84U',
        title: 'Al Ahadist Al Qudsiyah',
        ustadz: 'Ustadz Abu Yahya Badru Salam, Lc.',
    },
];

export default function Kajian() {
    return (
        <div className="pt-24 min-h-screen flex flex-col bg-[#081c1a] animate-fade-in-up">
            <div className="container mx-auto px-6 py-8 flex-1 flex flex-col">
                {/* Back Link */}
                <div>
                    <Link to="/belajar-islam" className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors mb-10 group">
                        <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        Kembali ke Belajar Islam
                    </Link>
                </div>

                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
                        Video Kajian <span className="text-gold">Ilmiah</span>
                    </h1>
                    <p className="text-muted-foreground max-w-2xl mx-auto text-lg mb-8">
                        Tonton kajian-kajian ilmiah pilihan dari para ulama, langsung dari channel YouTube kami.
                    </p>
                    <a
                        href="https://www.youtube.com/@ThubaProject/streams"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-full transition-all duration-300 shadow-xl shadow-red-900/40 hover:scale-105"
                    >
                        <Youtube size={20} /> Selengkapnya di Channel Youtube Kami <ExternalLink size={16} />
                    </a>
                </div>

                {/* Video Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-16">
                    {videos.map((video) => (
                        <a
                            key={video.id}
                            href={`https://www.youtube.com/watch?v=${video.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group block rounded-2xl overflow-hidden border border-white/10 bg-white/5 hover:border-gold/40 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-black/40"
                        >
                            {/* Thumbnail */}
                            <div className="relative overflow-hidden aspect-video">
                                <img
                                    src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                                    alt={video.title}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                                {/* Play Overlay */}
                                <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <div className="w-14 h-14 rounded-full bg-red-600/90 flex items-center justify-center shadow-lg">
                                        <Play size={24} className="text-white ml-1" fill="white" />
                                    </div>
                                </div>
                                {/* YouTube Badge */}
                                <div className="absolute top-3 right-3 bg-black/70 rounded-lg px-2 py-1 flex items-center gap-1">
                                    <Youtube size={14} className="text-red-500" />
                                    <span className="text-white text-xs font-semibold">YouTube</span>
                                </div>
                            </div>

                            {/* Info */}
                            <div className="p-4">
                                <h3 className="text-white font-semibold text-base leading-snug mb-1 group-hover:text-gold transition-colors duration-200">
                                    {video.title}
                                </h3>
                                <p className="text-muted-foreground text-sm">{video.ustadz}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
